import { useCallback, useEffect, useState } from "react";
import { adminApi } from "./adminApi";

export default function AdminOrders() {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");

  const load = useCallback(async () => {
    const { data } = await adminApi.get("/admin/orders");
    setData(data);
  }, []);
  useEffect(() => { load().catch(() => setError("Could not load orders. Click Refresh.")); }, [load]);

  const inr = (paise) => `₹${(paise / 100).toLocaleString("en-IN", { minimumFractionDigits: 2 })}`;

  return (
    <div data-testid="admin-orders">
      <h4 style={{ marginBottom: 4 }}>Orders & Revenue</h4>
      <span className="lead-sub">Only server-verified payments count as revenue. Pending and failed orders are tracked separately.</span>
      {error && <p className="admin-error" style={{ marginTop: 12 }}>{error}</p>}
      {data && <>
        {!data.summary.payments_live && <p className="admin-error" data-testid="orders-gateway">Payment gateway NOT configured — orders cannot be created until Razorpay keys are added.</p>}
        <div className="stat-cards" style={{ gridTemplateColumns: "repeat(auto-fill,minmax(160px,1fr))" }} data-testid="orders-summary">
          <div className="stat-card"><b style={{ fontSize: 22 }}>{inr(data.summary.collected_paise)}</b><span>COLLECTED (VERIFIED)</span></div>
          <div className="stat-card"><b style={{ fontSize: 22 }}>{data.summary.paid_count}</b><span>PAID ORDERS</span></div>
          <div className="stat-card"><b style={{ fontSize: 22 }}>{data.summary.pending_count}</b><span>PENDING</span></div>
          <div className="stat-card"><b style={{ fontSize: 22 }}>{data.summary.failed_count}</b><span>FAILED</span></div>
        </div>
        {data.orders.length === 0 ? <div className="admin-empty" data-testid="orders-empty">No orders yet. Orders appear here the moment a student starts checkout.</div> : (
          <div className="table-scroll"><table className="leads-table" data-testid="orders-table">
            <thead><tr><th>ORDER</th><th>STUDENT</th><th>ITEM</th><th>AMOUNT</th><th>STATUS</th><th>DATE</th></tr></thead>
            <tbody>{data.orders.map((o, i) => (
              <tr key={o.order_id} data-testid={`order-row-${i}`}>
                <td><div className="lead-name">{o.order_id}</div><div className="lead-sub">{o.rzp_payment_id || o.rzp_order_id}</div></td>
                <td><div className="lead-name">{o.student_name}</div><div className="lead-sub">{o.student_email}</div></td>
                <td>{o.item_name}<div className="lead-sub">{o.item_type}</div></td>
                <td><b>{inr(o.amount_paise)}</b></td>
                <td><span className={`status-pill ${o.status === "paid" ? "approved" : o.status === "failed" ? "rejected" : "locked"}`}>{o.status.toUpperCase()}</span></td>
                <td>{new Date((o.paid_at || o.created_at) * 1000).toLocaleString("en-IN", { day: "numeric", month: "short", hour: "numeric", minute: "2-digit" })}</td>
              </tr>
            ))}</tbody>
          </table></div>
        )}
      </>}
    </div>
  );
}
